export const canvasWidth = 600;
export const canvasHeight = 600;
export const MAX_HISTORY = 50;
export const HEX_COLOR = "#00FF00";
export const minFontSize = 30;
export const hexToRgba = (hex) => {
  const bigint = parseInt(hex.slice(1), 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
    a: 255,
  };
};
export const optionArr = [
  {
    name: "Main Fabric",
  },
  {
    name: "Design",
  },
  {
    name: "Thread Color",
  },
  {
    name: "Accent Color",
  },
  {
    name: "Personalize",
  },
  {
    name: "Size",
  },
  {
    name: "Add On",
  },
];

export const strapArr = [
  {
    name: "No Strap",
  },
  {
    name: "Canvas Strap",
  },
  {
    name: "Classic Leather Strap",
  },
  {
    name: "Exotic Leather Strap",
  },
  {
    name: "Regal Leather Strap",
  },
];

export const fontFamilyList = [
  "Baziporen, sans-serif",
  "Talpiot, serif",
  "BA Platforma, sans-serif",
  "BA Yad Maran, sans-serif",
  "BA Tzahlulim, sans-serif",
  "BA Nizozot Regular, sans-serif",
  "Bahacorech Regular, sans-serif",
  "BA Segolta Regular, sans-serif",
  "BA Tzarfati Bold, sans-serif",
  "FB Empatica Bold, sans-serif",
  "FB Kidush Bold, sans-serif",
  "FB Liddar Bold, sans-serif",
  "FB Maarav Bold, sans-serif",
  "FB Melatef Mudgash, sans-serif",
  "FB Vayikra, sans-serif",
  "Lia Batkol Regular, sans-serif",
  "Lia Romantica Regular, sans-serif",
  "Ostrovsky Bold, sans-serif",
  "Prinles, sans-serif",
  "Puncher, sans-serif",
  "Rag Marom Regular, sans-serif",
  "Secely MF Bold, sans-serif",
  "Ploni Black, sans-serif",
  "Ploni Bold, sans-serif",
  "Arial, Helvetica, sans-serif",
  "Courier New, Courier, monospace",
  "Georgia, serif",
  "Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif",
  "Tahoma, Geneva, sans-serif",
  "Times New Roman, Times, serif",
  "Verdana, Geneva, sans-serif",
  "LiaSgula Regular",
];

export const createDefaultTextObject = (
  id = Date.now(),
  isHebrewMode = true
) => ({
  id,
  text: "",
  fontFamily: "Baziporen, sans-serif",
  fontSize: 48,
  color: "#FFD700",
  shape: "straight",
  lineHeight: 1.2,
  letterSpacing: 0,
  radius: 80,
  position: { x: canvasWidth / 2, y: canvasHeight / 2 },
  rotation: 0,
  isSelected: true,
  letterCount: 0,
  price: 0,
  textAlign: "right",
  isRtl: isHebrewMode ? true : false,
  zIndex: 0,
  scale: { x: 1, y: 1 },
  textEffect: "none", // "none" | "bevel" | "emboss" | "extrude3d"
  extrudeDepth: 6,
  innerShadowEnabled: false,
  innerShadowColor: "rgba(0,0,0,0.6)",
  innerShadowBlur: 6,
  innerShadowOffsetX: 3,
  innerShadowOffsetY: 3,
});
// export function formatMixedHebrewText(text, textAlign = "left") {
//   if (!text) return "";

//   // If textAlign is 'right', treat as RTL (Hebrew)
//   // If textAlign is 'left', treat as LTR (English)
//   // If textAlign is 'center', use auto-detection

//   let direction;
//   if (textAlign === 'right') {
//     direction = 'rtl';
//   } else if (textAlign === 'left') {
//     direction = 'ltr';
//   } else {
//     // Auto-detect based on content
//     direction = /[\u0590-\u05FF]/.test(text) ? 'rtl' : 'ltr';
//   }

//   if (direction === 'rtl') {
//     // For RTL text, reverse the entire string
//     // Split by lines to handle multiline correctly
//     const lines = text.split('\n');
//     return lines.map(line => line.split('').reverse().join('')).join('\n');
//   }

//   // For LTR text, return as is
//   return text;
// }
export function formatMixedHebrewText(text, textAlign = "right") {
  if (!text) return "";

  // Split the text into lines and process each one independently.
  // This prevents the entire text from being reversed across line breaks.
  const lines = text.split("\n");

  const processedLines = lines.map(line => {
    if (!line) return "";

    // Check if line contains any Hebrew characters
    const hasHebrew = /[\u0590-\u05FF]/.test(line);

    // Determine if we should use RTL word ordering as base for this line
    let isRtl = false;
    if (textAlign === "right") {
      isRtl = true;
    } else if (textAlign === "left") {
      isRtl = false;
    } else {
      isRtl = hasHebrew;
    }

    // If no Hebrew is present in this line, keep it in logical order
    if (!hasHebrew) return line;

    const segments = [];
    let currentType = null; // 'hebrew' or 'ltr'
    let currentSegment = "";

    for (const char of line) {
      const isCharHebrew = /[\u0590-\u05FF]/.test(char);
      const isNeutral = !isCharHebrew && !/[a-zA-Z0-9]/.test(char);

      let charType;
      if (isCharHebrew) {
        charType = "hebrew";
      } else if (isNeutral) {
        charType = "neutral";
      } else {
        charType = "ltr";
      }

      if (currentType === null) {
        currentType = charType === "neutral" ? "ltr" : charType;
        currentSegment = char;
      } else if (charType === "neutral") {
        // Sticky neutrals: Append spaces/punctuation to the current segment
        currentSegment += char;
      } else if (charType === currentType) {
        currentSegment += char;
      } else {
        // Type switch between Hebrew and LTR
        if (isRtl) {
          segments.unshift({ type: currentType, text: currentSegment });
        } else {
          segments.push({ type: currentType, text: currentSegment });
        }
        currentType = charType;
        currentSegment = char;
      }
    }

    if (currentSegment) {
      if (isRtl) {
        segments.unshift({ type: currentType, text: currentSegment });
      } else {
        segments.push({ type: currentType, text: currentSegment });
      }
    }

    // Final assembly for this line: reverse characters only for Hebrew segments
    let lineResult = "";
    for (const seg of segments) {
      if (seg.type === "hebrew") {
        lineResult += seg.text.split("").reverse().join("");
      } else {
        lineResult += seg.text;
      }
    }
    return lineResult;
  });

  return processedLines.join("\n");
}

export const calculateFontSize = (textLength, baseFontSize = 48) => {
  const maxFontSize = baseFontSize;
  if (textLength <= 5) {
    return maxFontSize;
  }
  const scale = Math.max(minFontSize, maxFontSize - textLength * 0.5);
  return Math.max(minFontSize, Math.min(maxFontSize, scale));
};
export const adjustColor = (hex, percent) => {
  // Helper to lighten/darken colors
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);

  r = Math.min(255, Math.max(0, r + percent));
  g = Math.min(255, Math.max(0, g + percent));
  b = Math.min(255, Math.max(0, b + percent));

  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
};